// extracted by mini-css-extract-plugin
export var content = "_d5-3";
export var list = "_d5-4";
export var settingsContent = "_d5-7";
export var settingsPanel = "_d5-8";
export var state = "_d5-6";
export var triggerBadge = "_d5-2";
export var triggerButton = "_d5-1";
export var triggerShell = "_d5-0";
export var unreadDot = "_d5-5";